import styled from 'styled-components';
import { down } from '../../../utils/styles/breakpoints';
import { CatalogButton as CatalogButtonBase } from '../../catalog/CatalogButton';
import { Box } from '../../layout/Box';
import { Flex } from '../../layout/Flex';
import { Typography } from '../../typography/Typography';

export const BusinessCardRoot = styled(Box)
    .withConfig({ displayName: 'BusinessCardRoot' })
    .attrs({
        width: '100%',
        overflow: 'hidden',
        b: { sm: 3 },
    })``;

export const BusinessCardContent = styled(Box)
    .withConfig({ displayName: 'BusinessCardContent' })
    .attrs({
        position: 'relative',
        background: 'var(--background-primary)',
        pb: 0,
    })``;

export const BusinessCardRow = styled(Flex)
    .withConfig({ displayName: 'BusinessCardRow' })
    .attrs({
        width: '100%',
        py: 0.75,
        px: { xs: 2, sm: 3 },
    })``;

export const Properties = styled(Flex)
    .withConfig({ displayName: 'Properties' })
    .attrs((props) => ({
        ...props,
        direction: 'row',
        alignItems: 'center',
        spacing: { sm: 2 },
    }))`
    ${down('sm')} {
        & > *:not(:last-child)::after {
            content: '•';
            display: inline-block;
            margin-left: 4px;
            margin-right: 8px;
            color: var(--color-primary);
        }
    }
`;

export const CatalogButton = styled(CatalogButtonBase)
    .withConfig({ displayName: 'CatalogButton' })
    .attrs((props) => ({
        ...props,
        size: 'm',
        flexGrow: props.flexGrow ?? 1,
        spacing: 0.5,
    }))``;

export const Title = styled(Typography)
    .withConfig({ displayName: 'Title' })
    .attrs((props) => ({
        ...props,
        variant: 'title2',
        weight: 'bold',
        overflow: 'hidden',
        lines: 2,
    }))``;
